export default __webpack_public_path__ + "static/proyecto1-e59e223ca2bd8e2efab5335df055ca0c.jpeg";